import axios from 'axios';

axios.defaults.timeout = 60000;
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.API_URL;

// 请求拦截器配置
axios.interceptors.request.use(set => {
  set.headers = {
    'Content-Type': 'application/json'
  };

  return set;
}, err => {
  return Promise.reject(err);
});

/**
 * post请求
 */
function doPost(url, params = {}){
  return axios.post(url, params);
}

/**
 * get请求
 */
function doGet(url, params = {}){
  return axios.get(url, {params: params});
}

export default {
  doPost,
  doGet,
}







// WEBPACK FOOTER //
// ./src/http/http.js